import { createAction, props } from '@ngrx/store';
import { BadResponseWithError } from '@shared/models/common.interface';

export const FETCH_PLATFORM_REQUEST = '[Games] Fetch PLATFORM request';
export const FETCH_PLATFORM_SUCCESS = '[Games] Fetch PLATFORM success';
export const FETCH_PLATFORM_FAILURE = '[Games] Fetch PLATFORM failure';

export const FETCH_GAMES_REQUEST = '[Games] Fetch games request';
export const FETCH_GAMES_SUCCESS = '[Games] Fetch games success';
export const FETCH_GAMES_FAILURE = '[Games] Fetch games failure';

export const CREATE_GAME_REQUEST = '[Games] Create game request';
export const CREATE_GAME_SUCCESS = '[Games] Create game success';
export const CREATE_GAME_FAILURE = '[Games] Create game failure';

export const UPDATE_GAME_REQUEST = '[Games] Update game request';
export const UPDATE_GAME_SUCCESS = '[Games] Update game success';
export const UPDATE_GAME_FAILURE = '[Games] Update game failure';

export const DELETE_GAME_REQUEST = '[Games] Delete game request';
export const DELETE_GAME_SUCCESS = '[Games] Delete game success';
export const DELETE_GAME_FAILURE = '[Games] Delete game failure';

export const fetchPlatformsRequests = createAction(FETCH_PLATFORM_REQUEST);
export const fetchPlatformsSuccess = createAction(
    FETCH_PLATFORM_SUCCESS,
    props<{ payload: any[] }>()
);
export const fetchPlatformsFailure = createAction(
    FETCH_PLATFORM_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const fetchGamesRequests = createAction(FETCH_GAMES_REQUEST);
export const fetchGamesSuccess = createAction(
    FETCH_GAMES_SUCCESS,
    props<{ payload: any }>()
);
export const fetchGamesFailure = createAction(
    FETCH_GAMES_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const createGameRequests = createAction(
    CREATE_GAME_REQUEST,
    props<{ payload: any }>()
);
export const createGameSuccess = createAction(
    CREATE_GAME_SUCCESS,
    props<{ payload: any }>()
);
export const createGameFailure = createAction(
    CREATE_GAME_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const updateGameRequests = createAction(
    UPDATE_GAME_REQUEST,
    props<{ body: any }>()
);
export const updateGameSuccess = createAction(
    UPDATE_GAME_SUCCESS,
    props<{ body: any }>()
);
export const updateGameFailure = createAction(
    UPDATE_GAME_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const deleteGameRequests = createAction(
    DELETE_GAME_REQUEST,
    props<{ gameId: string }>()
);
export const deleteGameSuccess = createAction(
    DELETE_GAME_SUCCESS,
    props<{ gameId: string }>()
);
export const deleteGameFailure = createAction(
    DELETE_GAME_FAILURE,
    props<{ payload: BadResponseWithError }>()
);
